import { useState, useMemo, useContext } from 'react';
import { StaticContext } from '@sm/webassets';

import useFeatureSet from './useFeatureSet';
import { SummaryFeatureTransformer } from '~pricing/transformers/summary';
import { FeatureSet, SummaryDisplayFeatureList } from '~pricing/lib/summaryPackages';

export default function useSummaryDisplayFeatures(
  features: FeatureSet,
  featureTransformer?: SummaryFeatureTransformer
): SummaryDisplayFeatureList {
  const {
    environment: { slLanguageLocale },
  } = useContext(StaticContext);

  const featureSetMap = useFeatureSet(features);
  const [displayFeatures, setDisplayFeatures] = useState<SummaryDisplayFeatureList>([]);

  useMemo(() => {
    if (featureTransformer) {
      const featureSetData = featureTransformer(featureSetMap, { locale: slLanguageLocale });
      setDisplayFeatures(featureSetData);
    }
  }, [featureSetMap, featureTransformer, slLanguageLocale]);

  return displayFeatures;
}
